import { render, staticRenderFns } from "./PrintBargeSaham.vue?vue&type=template&id=08f718ad&scoped=true&"
import script from "./PrintBargeSaham.vue?vue&type=script&lang=js&"
export * from "./PrintBargeSaham.vue?vue&type=script&lang=js&"
import style0 from "./PrintBargeSaham.vue?vue&type=style&index=0&id=08f718ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f718ad",
  null
  
)

export default component.exports